


































import { Vue, Component, Prop } from 'vue-property-decorator';

import BaseModal from '~/components/modals/BaseModal.vue';

@Component({
  components: { BaseModal },
})
export default class ConfirmModal extends Vue {
  @Prop(String) title: '{ No title }';
  @Prop(String) description: '{ No description }';
  @Prop(String) cancelLabel: '';
  @Prop(String) confirmLabel: '';
};
